"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const YearlyMonthlyValue_1 = tslib_1.__importDefault(require("./YearlyMonthlyValue"));
const PriceUnit_1 = tslib_1.__importDefault(require("./PriceUnit"));
class Price extends YearlyMonthlyValue_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '1', description: 'ID as returned by AoM' }),
    tslib_1.__metadata("design:type", String)
], Price.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Variabele leveringskosten (G1/gasregio 05)', description: 'Description of the tariff.' }),
    tslib_1.__metadata("design:type", String)
], Price.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsIn)(Object.values(PriceUnit_1.default)),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: PriceUnit_1.default.EUR_PER_M3, description: 'Unit of the tariff, actual value is in the `unitPrice` property.' }),
    tslib_1.__metadata("design:type", String)
], Price.prototype, "unit", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 1.99908, description: 'Price per unit of this tariff. Unit is defined in the `unit` property.' }),
    tslib_1.__metadata("design:type", Number)
], Price.prototype, "unitPrice", void 0);
exports.default = Price;
